import { render, staticRenderFns } from "./CataloguePage.vue?vue&type=template&id=37252a90&scoped=true"
import script from "./CataloguePage.vue?vue&type=script&lang=js"
export * from "./CataloguePage.vue?vue&type=script&lang=js"
import style0 from "./CataloguePage.vue?vue&type=style&index=0&id=37252a90&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37252a90",
  null
  
)

export default component.exports